import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy, Component, computed, effect, HostListener, inject
  , input, linkedSignal, OnDestroy, OnInit, signal, TemplateRef, ViewChild
} from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { ItmToolbarComponent } from '@itm/components/toolbar';
import { ILayoutConfig, LayoutService } from '@itm/services';
import { ActionName, IListAction, IListColumn } from '@itm/types';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import {
  GridModule, SearchService, ToolbarService, ExcelExportService, PdfExportService, FilterService, SortService, GroupService, PageService
  , ColumnChooserService, ColumnMenuService, FailureEventArgs, FilterSettingsModel, GridComponent, GroupSettingsModel
  , ToolbarItems, SelectionSettingsModel, ReorderService, ResizeService, SearchSettingsModel, ExcelQueryCellInfoEventArgs,
  PageSettingsModel,
  QueryCellInfoEventArgs,
  row,
  ExcelExportProperties,
  DetailRowService,
  DetailDataBoundEventArgs,
  IGrid,
  Grid,
  ResizeSettingsModel

} from '@syncfusion/ej2-angular-grids';
import { ContextMenuComponent, ContextMenuModule, MenuComponent, MenuModule, SelectEventArgs, SelectingEventArgs, SidebarModule, TabComponent, TabModule } from '@syncfusion/ej2-angular-navigations';
import { DataManager, UrlAdaptor, WebApiAdaptor } from '@syncfusion/ej2-data';
import { CacActionService } from 'app/modules/admin/cac/cac.action.service';
import { takeUntil } from 'rxjs';
import { SideBarManagerComponent } from '../popup/manager/sidebar-manager.component';
import { FuseDrawerComponent } from '@fuse/components/drawer';
import { ActionStatus, ActionType, IActions } from '../utilities';
import { CacNotifyService } from '../../shared/services/cac.notify.service';
import { ActionCentreKanbanComponent } from './action-centre-kanban.component';
import { EXPORT_FILE_NAME } from '@itm/constants';
import { AppEmbeddedService } from '@itm/services/app.embedded.service';
import moment from 'moment-timezone';
import { DateTimeFormation, Utilities } from '@itm/constants/utilities';
import { DynamicFormStore } from '@itm/store/states/dynamic-form.state';
import { ButtonModule, CheckBoxModule, SwitchModule } from '@syncfusion/ej2-angular-buttons';
import { format } from 'crypto-js';
import { ItmBaseComponent } from '@itm/components/itm.base.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'action-centre-list',
  templateUrl: './action-centre-list.component.html',
  styleUrls: ['./action-centre-list.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [
    // RouterOutlet, 
    CommonModule, ItmToolbarComponent
    // , FuseAlertComponent
    , MatInputModule
    , FuseDrawerComponent
    , MenuModule
    , DropDownListModule, SidebarModule
    , SideBarManagerComponent
    , ActionCentreKanbanComponent, TabModule, CheckBoxModule
    , GridModule, SwitchModule, ButtonModule, ContextMenuModule],
  providers: [SearchService,
    ToolbarService,
    ExcelExportService,
    PdfExportService,
    FilterService,
    SortService,
    GroupService,
    PageService,
    ColumnChooserService,
    ColumnMenuService,
    ReorderService,
    ResizeService,
    DetailRowService
  ],
})
export class ActionCentreListComponent extends ItmBaseComponent implements OnInit, OnDestroy {
  highlightedRowIndex: number = -1;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const innerHeight = event.target.innerHeight;
    this.gridHeight = innerHeight - (this.isMobile() ? this.adjustForMobile : this.adjustForDesktop);
    this.setGridWrapperHeight();

    let parentDiv = document.getElementById('kanbanWrapper');
    if (parentDiv) {
      (parentDiv as HTMLElement).style.height = this.kanbanHeight + 'px';
    }
  }

  @ViewChild('tab', { static: true }) tab: TabComponent;
  @ViewChild('kanban') kanban?: ActionCentreKanbanComponent;

  listGridHeightToReduce: any = 150
  kanbanHeight: any = 770;

  private readonly _layoutService = inject(LayoutService);
  private readonly _cacService = inject(CacActionService);
  private readonly _titleService = inject(Title);
  private readonly _cacNotifyService = inject(CacNotifyService);
  private readonly _appEmbeddedService = inject(AppEmbeddedService);
  private readonly _formStore = inject(DynamicFormStore);

  pageKey = signal<string>('');
  layoutConfig = signal<ILayoutConfig>(undefined);
  tabs = computed(() => this.layoutConfig()?.tabs);
  toolbar = computed(() => this.layoutConfig()?.toolbar ?? undefined);
  buttons = computed(() => {
    return this.toolbar().buttons.map(m => ({
      ...m,
      visible: this.isMobile() == false ? m.visible : (this.isMobile() && m.visibleOnMobile) ? true : false,
      // caption: this.isMobile() ? '' : m.caption
    }));
  });

  // actionMenus = computed(() => {
  //   return [{
  //     text: '...',
  //     iconCss: '',
  //     items: this.buttons()?.filter((f: any) => ['DoNotEscalate', 'Remind'].includes(f.name)).map((m: any) => {
  //       return {
  //         text: m.caption,
  //         id: m.name,
  //         iconCss: m.prefixIcon,
  //         enabled: true
  //       }
  //     })
  //   }]
  // });

  breadcrumb = computed(() => this.layoutConfig()?.breadcrumb);
  gridPage = input.required<string>({ alias: 'page' });
  listColumns = signal<IListColumn[]>(undefined);
  searchableColumns = computed(() => this.listColumns().filter(x => x.searchable == null || x.searchable == true).filter(x => x.field != null).map(x => x.field));
  exportFileName: any;

  @ViewChild('actionCentreDetailsSidebar') actionCentreDetailsSidebar: FuseDrawerComponent;
  @ViewChild('grid') public grid?: GridComponent;
  @ViewChild('childGrd') public childGrd?: GridComponent;
  @ViewChild('gridActionRequired') public gridActionRequired?: GridComponent;
  @ViewChild('gridActionedView') public gridActionedView?: GridComponent;
  @ViewChild('gridArchived') public gridArchived?: GridComponent;
  @ViewChild('menuObj') menuObj!: MenuComponent;

  activeGrid = linkedSignal<GridComponent>(() => this.gridActionRequired ?? undefined);

  pageSettings!: PageSettingsModel;
  selectionOptions?: SelectionSettingsModel;

  urlAdapterData!: DataManager;
  dsActionRequired!: DataManager;
  dsActioned!: DataManager;
  urlAdapterChildData!: DataManager;
  urlArchiveAdapterData!: DataManager;

  loadingIndicator!: any;

  @ViewChild('toolbarSwitchTemplate', { static: true }) toolbarSwitchTemplate!: TemplateRef<any>;
  public toolbarOptions: (ToolbarItems | { template: TemplateRef<any> })[] = [];
  public toolbarActionRequired: (ToolbarItems | { template: TemplateRef<any> })[] = [];

  toolbarType: any = 'list';
  contactId: any = null;
  description: string = '';
  dataStoreKey!: string;
  // @Input('page') gridPage = '1';
  openMode: 'full' | 'slider' = 'full';
  selectedRowIndex: any = null;
  allowFiltering: boolean = true;
  ActionType = ActionType;

  // showListView: boolean = true;
  tabsControl: any = {
    ListView: 0,
    ActionRequired: 1,
    ActionedView: 2,
    KanbanView: 3,
    ArchivedView: 4,
  }
  activeTab: any = this.tabsControl.ActionRequired;

  parentEmbeddedAppTypeId: any = 0
  occuredDateTimeText: any = 'Created At';
  textAlign = signal<string>('Center');

  isMobile = this._layoutService.isMobileView;
  rowMode = signal<'Horizontal' | 'Vertical'>('Horizontal');
  openingAudit = signal(false);

  toggleBtnText: any = 'Archived';
  isArchived: boolean = false;

  // @ViewChild('actionIdTemplate', { static: true }) actionIdTemplate!: any;
  // public childGrid: GridModel;

  constructor(private router: Router
    // , private host: ElementRef
  ) {
    super();

    effect(() => {
    },
      { allowSignalWrites: true })
  }

  ngAfterViewInit() {
    // console.log('ngAfterViewInit')
  }

  ngOnInit(): void {
    if (this.isMobile()) {
      this.activeTab = this.tabsControl.ListView;
    }
    else {
      this.activeTab = this.tabsControl.ActionRequired;
    }

    this.gridHeight = window.innerHeight - (this.isMobile() ? this.adjustForMobile : this.adjustForDesktop);
    this.setGridWrapperHeight();

    this._appEmbeddedService.appEmbeddedType$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(x => {
        if (x) {
          this.parentEmbeddedAppTypeId = x.parent;
        }
      });

    this.itmOnLayoutInit();

    this.initGrid();
    this.setEjsGridToolbar();

    this._layoutService.toolbarButtonClick$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(x => {
        if (x) {
          this.onToolbarButtonClick(x);
        }
      });

    this._layoutService.toolbarSwitchClick$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(x => {
        if (x) {
          // this.showListView = x.checked;
        }
      });

    this._cacNotifyService.receiveNotification$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(x => {
        if (x) {
          // this.onRefreshClicked();
        }
      });

    this._cacNotifyService.sendOpenSidebar$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(x => {
        if (x) {
          const data = JSON.parse(x);
          this.onClickAction(data.actionId)
        }
      });

    ////Open sidebar 
    const id = this._activatedRoute.snapshot.paramMap.get('id');
    if (id) {
      this.openSidebar(id)
    }
  }

  setLayout(layout: string): void {
    // Clear the 'layout' query param to allow layout changes
    this.router
      .navigate([], {
        queryParams: {
          layout: layout,
        },
        queryParamsHandling: 'merge',
      })
      .then(() => {
        // Set the config
        this._fuseConfigService.config = { layout };
      });
  }

  public onToolbarButtonClick(e: any): void {
    const actionName = e;
    if (actionName === ActionName.DoNotEscalate) {
      this.onDoNotEscalateClicked(e);
      return;
    }
    else if (actionName === ActionName.Remind) {
      this.onRemindClicked(e);
      return;
    }
    else if (actionName === ActionName.Archive) {
      this.onArchiveClicked();
      return;
    }
    else if (actionName === ActionName.Refresh) {
      this.onRefreshClicked();
      return;
    }
    else if (actionName === ActionName.Close) {
      this.onCloseClicked();
      return;
    }
    else if (actionName == 'XLSX') {
      this.onXlsxExportClicked();
      return;
    }
    else if (actionName == 'CSV') {
      this.onCsvExportClicked();
      return;
    }
    // else if (actionName == 'PDF') {
    //   this.onPdfExportClicked();
    //   return;
    // }
  }

  onCsvExportClicked(): void {
    // 'Grid_csvexport' -> Grid component id + _ + toolbar item name    
    const excelExportProperties: ExcelExportProperties = {
      hierarchyExportMode: 'All',
      columns: this.getExportedColumns(),
      fileName: this.exportFileName + '.csv',
    };
    this.activeGrid()?.csvExport(excelExportProperties);
  }

  onXlsxExportClicked(): void {
    // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
    const excelExportProperties: ExcelExportProperties = {
      hierarchyExportMode: 'Expanded',
      columns: this.getExportedColumns(),
      fileName: this.exportFileName + '.xlsx',
    };
    this.activeGrid()?.excelExport(excelExportProperties);
  }

  getExportedColumns() {
    const excelExportColumns: any = [];
    this.listColumns()?.filter(f => f.allowExport).forEach(col => {
      excelExportColumns.push({
        field: col.field,
        width: col.width,
        textAlign: col.align,
        headerText: col.headerText,
        format
      });
    });
    return excelExportColumns;
  }

  onDoNotEscalateClicked(e: any) {
    if (this.activeTab == this.tabsControl.ListView) {
      const selectedRows = (this.grid as GridComponent).getSelectedRecords();
      // const selectedRows = (this.grid as GridComponent).getSelectedRecords().map(x => x['id']);
      if (selectedRows && selectedRows.map(x => x['id']).length == 0) {
        this._toastr.showInfo('Select record(s) first.');
        return;
      }

      if (selectedRows && selectedRows.some((a: any) => a.actionTypeId != this.ActionType.Alert)) {
        this._toastr.showInfo(`The selected records are not eligible to make 'DO NOT ESCALATE'`);
        return;
      }
      this.doNotEscalate(selectedRows);
    }
  }

  onRemindClicked(e: any) {
    if (this.activeTab == this.tabsControl.ListView) {
      const selectedRows = (this.grid as GridComponent).getSelectedRecords();
      if (selectedRows && selectedRows.map(x => x['id']).length == 0) {
        this._toastr.showInfo('Select record(s) first.');
        return;
      }
      if (selectedRows && selectedRows.some((a: any) => a.actionTypeId != this.ActionType.Alert)) {
        this._toastr.showInfo(`The selected records are not eligible to make 'REMIND'`);
        return;
      }
      this.doRemind(selectedRows);
    }
  }

  onArchiveClicked() {
    if (this.activeTab == this.tabsControl.ListView) {
      const selectedRows = (this.grid as GridComponent).getSelectedRecords().map(x => x['id']);
      if (selectedRows && selectedRows.length == 0) {
        this._toastr.showSuccess('Select record(s) first.');
        return;
      }

      if (selectedRows.length > 0) {
        const confirmationMessage = `Are you sure you want to make 'ARCHIVE' ?`;
        const confirmation = this._fuseConfirmationService.open(
          {
            title: 'Confirmation',
            message: confirmationMessage,
            panelClass: "archive-dialog-panel",
            dismissible: true,
            icon: {
              show: true,
              color: 'info'
            },
            actions: {
              confirm: {
                show: true,
                label: 'Confirm',

              },
              cancel: {
                show: true,
                label: 'Cancel'
              }
            }
          }
        );
        confirmation.afterClosed().subscribe((result) => {
          // If the confirm button pressed...
          if (result === 'confirmed') {
            this._cacService.archive(selectedRows).subscribe((resp: any) => {
              if (resp.data.result > 0) {
                this.activeGrid().refresh();
                this._toastr.showSuccess(`Successfully applied (archive) ${resp.data.result} out of ${selectedRows.length} records.`);
              }
              else {
                this._toastr.showSuccess('No actions (archive) have been applied.');
              }
            })
          }
        });
      }
    }
  }

  resetGrid(grid: GridComponent): void {
    grid?.clearFiltering();
    grid?.clearSorting();
    grid?.goToPage(1);
    grid?.refresh();
  }

  onRefreshClicked(): void {
    if (this.activeTab == this.tabsControl.ListView) {
      this.resetGrid(this.grid);
    }
    if (this.isMobile()) {
      if (this.activeTab == this.tabsControl.ActionedView) {
        this.resetGrid(this.gridArchived);
      }
    }
    else {
      if (this.activeTab == this.tabsControl.ActionRequired) {
        this.resetGrid(this.gridActionRequired);
      }
      else if (this.activeTab == this.tabsControl.ActionedView) {
        this.resetGrid(this.gridActionedView);
      }
      else if (this.activeTab == this.tabsControl.KanbanView) {
        this.kanban.kanbanctrl?.refresh();
      }
      else if (this.activeTab == this.tabsControl.ArchivedView) {
        this.resetGrid(this.gridArchived);
      }
    }
  }

  onCloseClicked(): void {
    this._itmNavigationService.navigate('/');
  }

  onClickDoNotEscalate(e: any, id: any) {
    this.doNotEscalate([{ id }]);
  }

  onClickRemind(e: any, id: any) {
    this.doRemind([{ id }]);
  }

  doNotEscalate(selectedRows: any) {
    if (selectedRows.length > 0) {
      const confirmationMessage = `Are you sure you want to make 'DO NOT ESCALATE' ?`;
      const confirmation = this._fuseConfirmationService.open(
        {
          title: 'Confirmation',
          message: confirmationMessage,
          dismissible: true,
          panelClass: "donotescalate-dialog-panel",
          icon: {
            show: true,
            color: 'info'
          },
          actions: {
            confirm: {
              show: true,
              label: 'Confirm',
              // color: 'primary',

            },
            cancel: {
              show: true,
              label: 'Cancel'
            }
          }
        }
      );
      confirmation.afterClosed().subscribe((result) => {
        // If the confirm button pressed...
        const postData = [];
        selectedRows.map(x => x['id']).forEach(row => {
          postData.push({
            id: row, reason: 'Bulk action taken...'
          })
        });
        if (result === 'confirmed') {
          this._cacService.doNotEscalate(postData).subscribe((resp: any) => {
            if (resp.data.result > 0) {
              this.activeGrid().refresh();
              this._toastr.showSuccess(`Successfully applied (do not escalate)`); // ${resp.data.result} out of ${selectedRows.length} records.
            }
            else {
              this._toastr.showSuccess('No actions (do not escalate) have been applied.');
            }
          })
        }
      });
    }
  }

  doRemind(selectedRows: any) {
    if (selectedRows.length > 0) {
      const confirmationMessage = `Are you sure you want to make 'REMIND' ?`;
      const confirmation = this._fuseConfirmationService.open(
        {
          title: 'Confirmation',
          message: confirmationMessage,
          dismissible: true,
          panelClass: "reminder-dialog-panel",
          icon: {
            show: true,
            color: 'info'
          },
          actions: {
            confirm: {
              show: true,
              label: 'Confirm',

            },
            cancel: {
              show: true,
              label: 'Cancel'
            }
          }
        }
      );
      confirmation.afterClosed().subscribe((result) => {
        // If the confirm button pressed...
        if (result === 'confirmed') {
          this._cacService.remind(selectedRows.map(x => x['id'])).subscribe((resp: any) => {
            if (resp.data.result > 0) {
              this.activeGrid().refresh();
              this._toastr.showSuccess(`Successfully applied (reminder in an hour)`); // ${resp.data.result} out of ${selectedRows.length} records.
            }
            else {
              this._toastr.showSuccess('No actions (reminder in an hour) have been applied.');
            }
          });
        }
      });
    }
  }

  customiseCell(args: QueryCellInfoEventArgs) {
    this.addCssClassToStatusCell(args)
  }

  addCssClassToStatusCell(args: QueryCellInfoEventArgs) {
    if (args.column.field == 'statusText') {
      if (args.data['status'] === ActionStatus.New) {
        args.cell.classList.add('status-new');
      }
      else if (args.data['status'] === ActionStatus.Open) {
        args.cell.classList.add('status-open');
      }
      else if (args.data['status'] === ActionStatus.InProgress) {
        args.cell.classList.add('status-inprogress');
      }
      else if (args.data['status'] === ActionStatus.AutoResolve) {
        args.cell.classList.add('status-autoresolve');
      }
      else if (args.data['status'] === ActionStatus.Resolve) {
        args.cell.classList.add('status-resolve');
      }
      else if (args.data['status'] === ActionStatus.Cancelled) {
        args.cell.classList.add('status-cancelled');
      }
      else if (args.data['status'] === ActionStatus.DoNotEscalate) {
        args.cell.classList.add('status-donotescalate');
      }
      else if (args.data['status'] === ActionStatus.Escalated) {
        args.cell.classList.add('status-escalated');
      }
      else if (args.data['status'] === ActionStatus.Reminder) {
        args.cell.classList.add('status-reminder');
      }
      else if (args.data['status'] === ActionStatus.ReminderSent) {
        args.cell.classList.add('status-reminder-sent');
      }
      else if (args.data['status'] === ActionStatus.Resolved) {
        args.cell.classList.add('status-resolved');
      }
      else if (args.data['status'] === ActionStatus.Reject) {
        args.cell.classList.add('status-reject');
      }
      else if (args.data['status'] === ActionStatus.Approve) {
        args.cell.classList.add('status-approve');
      }
      else if (args.data['status'] === ActionStatus.Requested) {
        args.cell.classList.add('status-requested');
      }
      else {
        args.cell.classList.add('status-color');
      }
    }
  }

  onListActionPerformed(action: IListAction) {
    if (action.actionName == 'refresh') {
      this.activeGrid()?.refresh();
    }
  }

  setEjsGridToolbar(): void {
    // this.toolbarOptions = ['ColumnChooser', 'Search'];
    this.toolbarOptions = this.toolbarActionRequired = [
      'ColumnChooser',
      'Search',
      { template: this.toolbarSwitchTemplate }
    ];
  }

  itmOnLayoutInit(): void {
    this._activatedRoute.data.subscribe(routeData => {
      const pageKey = routeData['pageKey'];
      if (pageKey) {
        this.dataStoreKey = pageKey;
        this.pageKey.set(pageKey);
      }
      const layoutConfig: ILayoutConfig = routeData['config'];
      if (layoutConfig) {
        if (layoutConfig.components) {
          layoutConfig.components.sort((a, b) => {
            return a.sortOrder - b.sortOrder;
          })
          this.exportFileName = layoutConfig.components[0]?.exportFileName ?? EXPORT_FILE_NAME;
          this.listColumns.set(layoutConfig.components[0].listColumns)
        }
        this.layoutConfig.set(layoutConfig);

        this.hideCloseBtnByEmbeddedAppType();
      }
    });
    this._titleService.setTitle(this.layoutConfig()?.pageTitle);
    // this._changeDetectorRef.markForCheck();
  }

  public filterSettings?: FilterSettingsModel;
  public searchSettings?: SearchSettingsModel;
  public groupOptions?: GroupSettingsModel;
  public resizeSettings: ResizeSettingsModel;
  initGrid() {
    const gridPage = this.gridPage() == undefined || null ? 1 : Number(this.gridPage());

    this.pageSettings = { pageSizes: [20, 30, 45, 'All'], pageSize: 20, enableQueryString: false, currentPage: gridPage };
    this.selectionOptions = { checkboxOnly: true, mode: 'Row', type: 'Single' }
    this.resizeSettings = { mode: 'Auto' };
    this.loadingIndicator = { indicatorType: 'Spinner' };
    this.groupOptions = { showDropArea: false };
    this.filterSettings = {
      type: 'Excel',
      mode: 'OnEnter',
      itemsCount: 10,
      enableInfiniteScrolling: true,
      loadingIndicator: 'Spinner',
      showFilterBarStatus: true,
      immediateModeDelay: 1500
    };
    this.searchSettings = { fields: this.searchableColumns() };

    this.fetchActionList();

    if (!this.isMobile()) {
      this.fetchActionRequired();
      this.fetchActionedView();
    }

    this.fetchActionArchivedView();

    // this.setGridHeight();
  }

  dataBound(grid: GridComponent) {
    ////TODO, producing NaN
    if (!grid) return;
    let changedHeight = grid.element.getBoundingClientRect().height - parseInt(grid.height as string);

    //dynamically setting the grid height including header and footer 
    grid.height = parseInt(grid.height as string) - changedHeight;

    if (this.openMode === 'slider') {
      if (this.selectedRowIndex) {
        this.selectThisRow(grid, this.selectedRowIndex);
      }
    }
  }

  onListViewDataBound() {
    this.dataBound(this.grid);
  }

  onActionRequiredDataBound() {
    this.dataBound(this.gridActionRequired);
  }

  onActionedDataBound() {
    this.dataBound(this.gridActionedView);
  }

  onArchiveDataBound() {
    this.dataBound(this.gridArchived);
  }

  childGridExcelQueryCellInfo(args: ExcelQueryCellInfoEventArgs) {
    if (args.column.type === 'datetime') {
      const formattedDate = this.formatByTimezone(args.data, args.column.foreignKeyField, '');
      args.value = formattedDate;
    }
  }

  excelQueryCellInfo(args: ExcelQueryCellInfoEventArgs) {
    const val: any = args.value;
    if (args.column.type === 'datetime') {
      //   let p: any = new Intl.DateTimeFormat('en',{
      //     year:'numeric',
      //     month:'2-digit',
      //     day:'2-digit',
      //     hour:'2-digit',
      //     minute:'2-digit',
      //     second:'2-digit',
      //     hour12: true
      //   }).formatToParts(val).reduce((acc, part) => {
      //       acc[part.type] = part.value;
      //       return acc;
      //   }, {});

      // args.value =  `${p.day}/${p.month}/${p.year} ${p.hour}:${p.minute}:${p.second}`; 
      args.value = this.formatByTimezone(args.data, args.column.foreignKeyField, ''); //  val.toLocaleString("en-NZ", { hour12: false }); 
    }
    else if (args.column.type === 'date') {
      let p: any = new Intl.DateTimeFormat('en', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      }).formatToParts(val).reduce((acc, part) => {
        acc[part.type] = part.value;
        return acc;
      }, {});

      args.value = `${p.day}/${p.month}/${p.year}`;
    }
  }

  fail(e: FailureEventArgs) {
    // handle the error.
  }

  selectThisRow(grid: GridComponent, rowIndex: any) {
    const row = grid.getRowByIndex(rowIndex);
    if (row) {
      document.querySelectorAll('.e-row').forEach(row => row.classList.remove('selected-row'));
      row.classList.add('selected-row');
    }
  }

  beforeDataBound(args: any): void {
    try {
      if (this.openMode === 'slider') {
        let gridData = args.result;
        let newFormId = this.getIdFromUrl();
        const selectedIndex = gridData.findIndex((r: any) => r.pId === newFormId);

        if (selectedIndex !== -1) {
          this.selectedRowIndex = selectedIndex;
        } else {
          this.selectedRowIndex = null;
        }
      }
    } catch (error) {
      this.selectedRowIndex = null;
    }
  }

  getIdFromUrl() {
    try {
      if (this.openMode === 'slider') {
        let url = window.location.href;

        let urlObj = new URL(url);
        let path = urlObj.pathname;

        let parts = path.split('/');
        let newFormId = parts[parts.length - 1]?.trim();

        return newFormId;
      }
    } catch (error) {
      return "";
    }
  }

  ngOnDestroy(): void {
    this._layoutService.dataStoreRemoveItem(this.dataStoreKey);
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  handleListActionButton(e: CustomEvent): void {
    // this.onActionButton(e);
  }

  selectedAction = signal(undefined);
  onClickAction(id: any) {
    this._formStore.setEntityId(id);
    const url = `${window.location.href}/${id}`
    window.history.pushState({ path: url }, '', url);
    this.openSidebar(id);
  }

  onOpenAudit(data: any) {
    this.openingAudit.set(true);
    this._formStore.setEntityId(data.id);
    this.selectedAction.set({
      'id': data.id,
      'actionTitle': `Audit Trail - ${data.action_Id}`
    });
    this.actionCentreDetailsSidebar?.toggle();
  }

  closeClick() {
    this.openingAudit.set(false);
    this.activeGrid()?.refresh();
    this.actionCentreDetailsSidebar?.close();
  }

  drawerOpen(isOpened: any) {
    this._cacNotifyService.setSidebarOpenedStatus(isOpened);
    if (isOpened == false) {
      this.openingAudit.set(false);
      const url = `${window.location.origin}/action-centre`
      window.history.pushState({ path: url }, '', url);
    }
  }

  openSidebar(id: any) {
    this._formStore.setEntityId(id);
    this.selectedAction.set({});
    this._cacService.getActionById<IActions>(id).subscribe((resp: any) => {
      const { result } = resp.data.data;
      if (result) {
        result.actionTitle = `${result.actionTitle} - ${result.action_Id}`
      }
      this.selectedAction.set(result);
      this.actionCentreDetailsSidebar?.toggle();
    },
      (error: any) => {
        const url = `${window.location.origin}/action-centre`
        window.history.pushState({ path: url }, '', url);
        this._toastr.showError(`Something went wrong... Error: ${error}`);
      });
  }

  private setActiveTab(selectedIndex: any) {
    let interval = undefined;
    if (selectedIndex == 0) {
      this.activeTab = this.tabsControl.ActionRequired;
      interval = setInterval(() => {
        if (this.gridActionRequired) {
          clearInterval(interval);
          this.activeGrid.set(this.gridActionRequired);
        }
      }, 200);
    }
    // else if (selectedIndex == 1) {
    //   this.activeTab = this.tabsControl.ActionedView;
    //   interval = setInterval(() => {
    //     if (this.gridActionedView) {
    //       clearInterval(interval);
    //       this.activeGrid.set(this.gridActionedView);
    //     }
    //   }, 200);
    // }
    else if (selectedIndex == 1) {
      this.activeTab = this.tabsControl.ListView;
      interval = setInterval(() => {
        if (this.grid) {
          clearInterval(interval);
          this.activeGrid.set(this.grid);
        }
      }, 200);
    }
    // else if(selectedIndex == 3){
    //   this.activeTab = this.tabsControl.KanbanView;
    // }
    else if (selectedIndex == 2) {
      this.activeTab = this.tabsControl.ArchivedView;
      interval = setInterval(() => {
        if (this.gridArchived) {
          clearInterval(interval);
          this.activeGrid.set(this.gridArchived);
        }
      }, 200);
    }
  }

  private refreshActiveTabView() {
    if (this.activeTab == this.tabsControl.ListView) {
      this.grid?.refresh();
    }
    else if (this.activeTab == this.tabsControl.ActionRequired) {
      this.gridActionRequired?.refresh();
    }
    else if (this.activeTab == this.tabsControl.ActionedView) {
      this.gridActionedView?.refresh();
    }
    else if (this.activeTab == this.tabsControl.ArchivedView) {
      this.gridArchived?.refresh();
    }
    else if (this.activeTab == this.tabsControl.KanbanView) {
      this.kanban?.kanbanctrl?.refresh();
    }
  }

  public clickTabs(e: SelectEventArgs) {
    this.setActiveTab(e.selectedIndex);

    this.refreshActiveTabView();

    this.toolbar()?.buttons.map((m: any) => {
      if (['DoNotEscalate', 'Remind', 'Archive', 'Export'].includes(m.name))
        m.visible = this.activeTab == this.tabsControl.ListView
    });
  }

  public select(e: SelectingEventArgs) {
  }

  public actionBegin(args: any, grid: GridComponent): void {
    if (args.requestType === 'paging') {
      // Prevent default behavior or URL modification
      grid.goToPage(args.currentPage);
      this.router.navigate([], {
        queryParams: {}, // Clear query parameters
        replaceUrl: true,
      });
    }
  }

  onListViewActionBegin(args: any) {
    if (['filterBeforeOpen'].includes(args.requestType) && ['datetime'].includes(args.columnType)) {
      const interval = window.setInterval(() => {
        const filterElements = document.querySelectorAll('.e-searchcontainer .e-checkboxfiltertext');
        if (filterElements && filterElements.length > 0) {
          clearInterval(interval);

          const searchBox = document.querySelectorAll('.e-searchcontainer .e-searchbox');
          searchBox.forEach((s: any) => {
            s.style.display = "none";
          });

          filterElements.forEach((element) => {
            const text = element.textContent?.trim();
            if (text === 'True') {
              element.textContent = 'Yes';  // Replace "true" with "Yes"
            } else if (text === 'False') {
              element.textContent = 'No';   // Replace "false" with "No"
            }
          });
        }
      }, 100);
    }

    // const { columnName } = args;
    // if(args.requestType == 'filterBeforeOpen'){
    //   const { filterModel } = args;

    //   const interval = setInterval(() => {
    //     const { filteredData } = filterModel;
    //     if(filteredData){
    //       clearInterval(interval);
    //       filteredData.forEach(row => {
    //           row.occuredDateTime = moment(row[columnName]).tz(Utilities.DEFAULT_TIMEZONE).format(Utilities.FORMAT_FULL_DATETIME);
    //       });
    //     }
    //   }, 200);
    // }
    this.actionBegin(args, this.grid);
  }

  onArchivedViewActionBegin(args: any) {
    this.actionBegin(args, this.gridArchived);
  }

  hideCloseBtnByEmbeddedAppType() {
    if (this.parentEmbeddedAppTypeId > 0) {
      this.toolbar()?.buttons.map((m: any) => {
        if (['Close'].includes(m.name))
          m.visible = false;
      });
    }
  }

  formatByTimezone(data: any, field: string, format: string) {
    if (!data) return;
    format = format || Utilities.FORMAT_FULL_DATETIME;
    return moment(data[field]).tz(Utilities.DEFAULT_TIMEZONE).format(format);
  }

  getChildDataSource(parentId: number): DataManager {
    const composedURL = `${this._http.GET_API_URL()}cac/action/list/child?parentId=${parentId}`;
    var childGridData = new DataManager({
      url: composedURL,
      headers: [{ 'Authorization': `Bearer ${this._itmUserService.getAccessTokenLocalStorage()}` }],
      adaptor: new WebApiAdaptor
    });
    return childGridData;
  }

  detailDataBound(args: DetailDataBoundEventArgs) {
    const data = args.data as any;
    if (data.hasChild) {
      let detail = new Grid({
        dataSource: this.getChildDataSource(data.id),
        queryCellInfo: this.childGridCellFormatter.bind(this),
        excelQueryCellInfo: this.childGridExcelQueryCellInfo.bind(this) // Add this
      });

      if (this.isMobile()) {
        detail.columns = [
          { field: 'id', headerText: 'id', visible: false },
          { field: 'subject', headerText: 'Subject' },
          {
            field: 'statusText',
            headerText: 'Status',
            textAlign: 'Center',
            width: "120",
            // template: `<a class='edit-name-link child-action' href='javascript:void(0)' data-id='\${id}'>\${statusText}</a>`
            template: `<a class='child-action' href='javascript:void(0)' data-id='\${id}'><div class='status text-white rounded-[9999px] pt-[2px] pb-[3px] pl-[4px] pr-[4px]'>\${statusText}</div></a>`
          }
        ]
      }
      else {
        detail.columns = [
          // { field: 'action_Id', headerText: 'Action Id' },
          {
            field: 'action_Id',
            headerText: 'Action Id',
            // template: this.actionIdTemplate   // Bind the template here
            // template: `<a class='edit-name-link child-action' href='javascript:void(0)' data-id='\${id}'>\${action_Id}</a>`
          },
          {
            field: 'occuredDateTime',
            headerText: 'Created At',
            type: 'datetime',
            textAlign: 'Center',
            // format: 'dd/MM/yyyy HH:mm:ss'
          },
          { field: 'branchId', headerText: 'Branch Id' },
          { field: 'subject', headerText: 'Subject' },
          {
            field: 'statusText',
            headerText: 'Status',
            textAlign: 'Center',
            width: "120",
            // template: `<div class='status'>\${statusText}</div>`
            template: `<a class='child-action' href='javascript:void(0)' data-id='\${id}'><div class='status text-white rounded-[9999px] pt-[2px] pb-[3px] pl-[4px] pr-[4px]'>\${statusText}</div></a>`
          }
        ]
      }

      const interval = setInterval(() => {
        const gridContainer = (args.detailElement as HTMLElement).querySelector('.custom-grid') as HTMLElement;
        if (gridContainer) {
          clearInterval(interval);
          detail.appendTo(gridContainer);

          (detail as IGrid).element.addEventListener('click', (event) => {
            const target = event.target as HTMLElement;
            if (target) {
              const href = target.parentElement;
              if (href) {
                if (href.classList.contains('child-action')) {
                  const id = href.getAttribute('data-id');
                  if (id) {
                    this.onClickAction(id);
                  }
                }
              }
            }
          });
        }
      }, 500);
    }
  }

  exportDetailDataBound(args: any) {
    console.log(args)
    // childGrid.dataSource = new DataManager({
    //   url: 'https://services.odata.org/V4/Northwind/Northwind.svc/Orders',
    //   adaptor: new ODataV4Adaptor(),
    // });
    // childGrid.query = new Query().where(
    //   'CustomerID',
    //   'equal',
    //   row.data.CustomerID
    // );
  }

  toggleChildGrid(e: any, rowData: any, grid: GridComponent): void {
    e.stopPropagation();

    const rowIndex = grid.getRowIndexByPrimaryKey(rowData.id);
    const row = grid.getRowByIndex(rowIndex);
    const nextRow = row?.nextElementSibling;
    // Look for whether the row is already expanded
    const isExpanded = nextRow?.classList.contains('e-detailrow');
    if (isExpanded) {
      grid.detailRowModule?.collapse(rowIndex);
      grid.refresh();
      // nextRow.remove();
    } else {
      grid.detailRowModule?.expand(rowIndex);
    }

    const element = e.currentTarget as HTMLElement;
    if (element.classList.contains('e-swimlane-row-collapse')) {
      element.classList.remove('e-swimlane-row-collapse');
      element.classList.add('e-swimlane-row-expand');
    } else {
      element.classList.remove('e-swimlane-row-expand');
      element.classList.add('e-swimlane-row-collapse');
    }
  }

  dateTimeFormation = DateTimeFormation;
  childGridCellFormatter(args: QueryCellInfoEventArgs) {
    let fieldName = 'occuredDateTime'
    if (args.column.field === fieldName && args.data[fieldName]) {
      const rawDate = args.data[fieldName];
      const formattedDate = moment(args.data[fieldName]).tz(Utilities.DEFAULT_TIMEZONE).format(this.dateTimeFormation.FORMAT_FULL_DATETIME);
      // this.formatByTimezone(args.data, fieldName, '');
      args.cell.innerHTML = formattedDate;
    }

    this.addCssClassToStatusCell(args)
  }

  // public childDataSources: { [key: number]: DataManager } = {};
  childDataSources: { [key: string]: any[] } = {};
  rowDataBound(args: any) {
    // if (!args.data.hasChild) {
    // Remove expand icon if no child

    // const data = args.data as any;
    // if (data.hasChild == true && !this.childDataSources[data.id]) {
    //   this.childDataSources[data.id] = this.getChildDataSource(data.id);
    // }

    let cell = args.row.querySelector('.e-detailrowcollapse');
    if (cell) {
      // cell.remove();
      const anchorTag = cell.querySelector('a');
      if (anchorTag) {
        anchorTag.style.display = 'none';
      }
    }
    // }
  }

  onArchivedChange(event: any): void {
    this.isArchived = !this.isArchived;
    if (this.isArchived == true) {
      this.toggleBtnText = 'All Actions';
      this.tab?.select(1);
      this.fetchActionArchivedView();
      // this.gridArchived.hideColumns(['Select'], 'headerText');
    }
    else {
      this.tab?.select(0);
      this.toggleBtnText = 'Archived';
      this.fetchActionList();
      // this.grid.hideColumns(['Select'], 'headerText');
    }
  }

  fetchActionList() {
    let composedURL = `${this._http.GET_API_URL()}cac/action/list/${this.parentEmbeddedAppTypeId}/1`;
    this.urlAdapterData = new DataManager({
      url: composedURL,
      headers: [{ 'Authorization': `Bearer ${this._itmUserService.getAccessTokenLocalStorage()}` }],
      adaptor: new UrlAdaptor(),
    });
  }

  fetchActionRequired() {
    let composedURL = `${this._http.GET_API_URL()}cac/action/list/${this.parentEmbeddedAppTypeId}/2`;
    this.dsActionRequired = new DataManager({
      url: composedURL,
      headers: [{ 'Authorization': `Bearer ${this._itmUserService.getAccessTokenLocalStorage()}` }],
      adaptor: new UrlAdaptor(),
    });
  }

  fetchActionedView() {
    let composedURL = `${this._http.GET_API_URL()}cac/action/list/${this.parentEmbeddedAppTypeId}/3`;
    this.dsActioned = new DataManager({
      url: composedURL,
      headers: [{ 'Authorization': `Bearer ${this._itmUserService.getAccessTokenLocalStorage()}` }],
      adaptor: new UrlAdaptor(),
    });
  }

  fetchActionArchivedView() {
    let composedURL = `${this._http.GET_API_URL()}cac/action/list/${this.parentEmbeddedAppTypeId}/4`;
    this.urlArchiveAdapterData = new DataManager({
      url: composedURL,
      headers: [{ 'Authorization': `Bearer ${this._itmUserService.getAccessTokenLocalStorage()}` }],
      adaptor: new UrlAdaptor(),
    });
  }

  rowDataForMenu: any;
  actionMenuItemsData: any[] = [];
  @ViewChild('actionContextMenu') actionContextMenu!: ContextMenuComponent;

  private buildActionMenuItems(row: any): any[] {
    if (!row) return [];

    const actionButton = row.actionButton;
    return this.buttons()?.filter((f: any) => ['DoNotEscalate', 'Remind'].includes(f.name)).map((m: any) => {
      let actionDisabled = false;
      if (m.name == 'DoNotEscalate') {
        actionDisabled = actionButton ? !actionButton.disabledDoNotEscalate : actionDisabled;
      }
      else if (m.name == 'Remind') {
        actionDisabled = actionButton ? !actionButton.disabledReminder : actionDisabled;
      }
      return {
        text: m.caption,
        id: m.name,
        iconCss: `${m.prefixIcon} action-item`,
        enabled: actionDisabled
      }
    }) ?? [];
  }
  
  onClickActionContextMenu(event: MouseEvent, rowData: any) {
    // console.log('openContextMenu', event, rowData);
    event.preventDefault(); // stop normal click
    this.rowDataForMenu = rowData;  // store row data for later use
    console.log('actionMenuItemsData rowData', rowData);
    this.actionMenuItemsData = this.buildActionMenuItems(rowData);
    this.actionContextMenu.open(event.pageY, event.pageX);
  }

  onSelectActionContextMenu(e: any) {
    // console.log('Menu clicked:', e);
    if (!this.rowDataForMenu) return;
    const buttonText = e?.item?.properties?.id;
    if (buttonText != '') {
      if (buttonText === ActionName.DoNotEscalate) {
        this.onClickDoNotEscalate(e, this.rowDataForMenu.id);
        return;
      }
      else if (buttonText === ActionName.Remind) {
        this.onClickRemind(e, this.rowDataForMenu.id);
        return;
      }
    }
  }

  onRowSelected(event: any) {
    const rowData = event.data;

  }

  onRowDeselected(event: any) {
    const rowData = event.data;

    const uncheckedRow = document.querySelector(`.e-grid .e-row[data-rowindex="${event.rowIndex}"]`);
    if (uncheckedRow) {
      uncheckedRow.classList.remove('row-highlighted');
    }

    if (this.highlightedRowIndex === event.rowIndex) {
      this.highlightedRowIndex = -1;
    }
  }
  onRecordClick(args: any) {
    const rowData = args.data;
    const rowIndex = args.rowIndex;

    const target = args.event?.target;
    if (target && (target.type === 'checkbox' || target.closest('.e-checkselect'))) {
        return;
    }

    this.highlightedRowIndex = rowIndex;

    
    document.querySelectorAll('.e-grid .e-row').forEach(row => {
        row.classList.remove('row-highlighted');
    });

    
    let activeGrid: GridComponent | undefined;
    if (this.activeTab === this.tabsControl.ActionRequired) {
        activeGrid = this.gridActionRequired;
    } else if (this.activeTab === this.tabsControl.ActionedView) {
        activeGrid = this.gridActionedView;
    } else if (this.activeTab === this.tabsControl.ListView) {
        activeGrid = this.grid;
    } else if (this.activeTab === this.tabsControl.ArchivedView) {
        activeGrid = this.gridArchived;
    }

    if (activeGrid) {
        const clickedRow = activeGrid.getRowByIndex(rowIndex);
        if (clickedRow) {
            clickedRow.classList.add('row-highlighted');
        }
    }
}

  
}

export interface childColumnDataType {
  id: string,
}